import { memo } from 'react';

import styles from '@/creditflowresearch/ui/components/deals/DealListTable/components/DealBody/DealDetails/dealDetails.module.scss';

interface IProps {
  label?: string,
  value: React.ReactNode | string,
  isHtml?: boolean,
}

const Detail = ({ label, value, isHtml = false }: IProps) => (
  !!value && (
    <div className={ styles.detail }>
      <div className={ styles.detailLabel }>{ label }</div>
      {
        isHtml ? (
          <div
            className={ styles.detailText }
            dangerouslySetInnerHTML={ { __html: value as string } }
          />
        ) : (
          <div className={ styles.detailText }>
            { value }
          </div>
        )
      }
    </div>
  )
);

export default memo(Detail);
